<template>
    <v-form
        ref='send-identity-doc'
        lazy-validation
        v-model='validIdentityDoc'
        :disabled='loading'
        @submit.prevent='submitIdentityDoc(manager)'
    >
        <v-row>
            <v-col cols='12'>


                <ImageUploader
                    :disableUploadPhotoLength='2'
                    label='تصویر کارت ملی (پشت و رو)'
                    target='id_card--'
                    :required="manager.identityDoc.idPhotos < 1"
                    v-model='manager.identityDoc.idPhotos'
                />
            </v-col>
            <v-col cols='12'>

                <ImageUploader
                    :disableUploadPhotoLength='15'
                    label='قراردادها'
                    :required="true"
                    :target='`apartmentDocs--${apartment._id}--`'
                    v-model='apartmentDocs'
                >
                    <template #alert>
                        <InfoAlert>
                            <ul>
                                <li>هم اکنون وضعیت مجموعه شما ``تکمیل اطلاعات شده`` میباشد میتوانید. جهت تایید مجموعه
                                    بارگذاری مدارک زیر الزامیست
                                </li>
                                <li>بعد از دانلود قرارداد های زیر، آن ها را مطالعه و تکمیل کرده و نسخه امضا شده آن را
                                    بارگذاری کنید
                                </li>
                            </ul>
                            <template slot='action'>
                                <v-btn
                                    outlined
                                    :block='$vuetify.breakpoint.smAndDown'
                                    color='primary'
                                    class='mb-2 mb-md-0'
                                    href='/صورت-جلسه-مجمع-مالکین-و-ساکنین.pdf'
                                    download
                                >
                                    <div>
                                        <v-icon class='ml-1'>mdi-download</v-icon>
                                        <span>فایل صورت جلسه</span>
                                    </div>
                                </v-btn>
                                <v-btn
                                    outlined
                                    :block='$vuetify.breakpoint.smAndDown'
                                    class='mr-0 mr-md-2'
                                    color='primary'
                                    href='/گواهی-پذیرش-قوانین-ملکبا-برای-مدیران-ساختمان.pdf'
                                    download
                                >
                                    <div>
                                        <v-icon class='ml-1'>mdi-download</v-icon>
                                        <span>فایل گواهی پذیرش قوانین</span>
                                    </div>
                                </v-btn>
                            </template>
                        </InfoAlert>
                    </template>
                </ImageUploader>
            </v-col>

            <v-col cols='12' md='4'>
                <BankCardNumberInput
                    :value='cardNumber'
                    label='شماره کارت بانکی'
                    placeholder='#### #### #### ####'
                    type='text'
                    v-mask="'#### #### #### ####'"
                    @input='handleInputCardNumber($event,"cardNumber")'
                    :rules='rules.cardNumber'
                    :hint='getBankNameFromCardNumber(manager.cardNumber)'
                />
            </v-col>
            <v-col cols='12' md='4'>
                <BankCardNumberInput
                    v-model='manager.shebaNumber'
                    label='شماره شبا'
                    type='text'
                    :rules='rules.shebaNumber'
                    hint='نیاز به وارد کردن "IR" نیست'
                />
            </v-col>
            <v-col cols='12' md='4'>
                <BankCardNumberInput
                    v-model='manager.accountNumber'
                    label='شماره حساب'
                    hide-details
                />
                <div slot='message'>
                    <span>{{ shebaInfo.persianName }}</span>
                </div>
            </v-col>

        </v-row>
        <v-row>
            <v-col cols="12">
                <InfoAlert >
                    <ul>
                        <li><a href="https://melkba.com/blog/9054/" target="_blank">مطالعه متن کامل قوانین استفاده از امکانات مدیریت مجموعه در پلتفرم ملکبا</a></li>
                    </ul>
                </InfoAlert>
                <v-checkbox
                    v-model='acceptTheRules'
                    :rules='rules.acceptTheRules'
                    required
                    class='rtl mt-0'
                >
                    <template slot="label">
                        <div>
                            <strong class='red--text'>* </strong>
                            <span class="black--text">با انتخاب این گزینه تایید میکنید که <a>قوانین استفاده از امکانات مدیریتی مجموعه در پلتفرم ملکبا</a> را خوانده اید و میپذیرید.</span>
                        </div>
                    </template>
                </v-checkbox>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols='12'>
                <v-card-actions class='pa-0'>
                    <v-btn
                        outlined
                        @click='goToStep(4)'
                    >
                        مرحله قبل
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        :loading='loading'
                        :disabled='loading || !validIdentityDoc  || !acceptTheRules'
                        type='submit'
                        color='primary'
                        @click='validateIdentityDoc'
                    >ثبت
                    </v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
        <v-dialog v-model='finalStepDialog' persistent max-width='420'>
            <v-card outlined>
                <v-card-title class='subtitle-1'>
                    <div>
                        <span>مجموعه </span>
                        <span class='font-weight-bold'>{{ apartment.title }}</span>
                        <span> ثبت شد</span>
                    </div>
                </v-card-title>
                <v-card-text>
                    <span>برای ثبت اطلاعات ساکنین مجموعه، در بخش </span>
                    <span class='font-weight-bold text--primary'>عملیات‌ها </span>
                    <span>گزینه </span>
                    <span class='font-weight-bold text--primary'>ساکنین </span>
                    <span>را انتخاب کرده و اطلاعات ساکنین مجموعه را وارد کنید</span>
                </v-card-text>
                <v-card-actions :class='$vuetify.breakpoint.smAndDown ? "flex-column" : ""'>
                    <v-btn
                        :block='$vuetify.breakpoint.smAndDown'
                        class='mb-2 mb-md-0'
                        @click='skipAddResidentsInfo'
                        outlined
                    >بعدا ثبت میکنم
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        :block='$vuetify.breakpoint.smAndDown'
                        class='mr-0 mr-md-2'
                        @click='goToAddResidentInfo'
                        color='primary'
                    >ثبت اطلاعات ساکنین
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
import axios from "axios";
import {createSupportRequest} from "@/plugins/createSupportRequest";
import InfoAlert from "@/components/Alerts/InfoAlert";
import ImageUploader from "@/components/ImageUploader";
import BankCardNumberInput from "@/components/BankCardNumberInput";
import {getBankNameFromCardNumber, getShebaInfo, isShebaValid, verifyCardNumber} from "@persian-tools/persian-tools";
import {mapActions} from "vuex";

export default {
    name: "validationInfo",
    components: {BankCardNumberInput, ImageUploader, InfoAlert},
    props: {
        apartment: Object,
        goToStep: Function,
        step: Number,
        supportRequest_id: String
    },
    model: {
        prop: 'apartment',
        event: 'updateApartment'
    },
    data() {
        return {
            loading: false,
            validIdentityDoc: false,
            finalStepDialog: false,
            acceptTheRules:false,
            manager: {
                identityDoc: {
                    idPhotos: []
                },
                cardNumber: '',
                accountNumber: '',
                shebaNumber: ''
            },
            apartmentDocs: [],

            cardNumber: '',
            accountNumber: '',
            shebaNumber: '',

            rules: {
                cardNumber: [
                    v => !v ? true : verifyCardNumber(v.replace(/ /g, '')) ? true : 'شماره کارت وارد شده صحیح نیست'
                ],
                shebaNumber: [
                    v => !v ? true : isShebaValid('IR' + v) ? true : 'شماره شبا وارد شده صحیح نیست'
                ],
                acceptTheRules:[
                    v => !v ? 'پذیرش و مطالعه قوانین الزامیست' : true
                ]
            }
        }
    },
    methods: {

        getBankNameFromCardNumber(v) {
            return getBankNameFromCardNumber(v);
        },
        handleInputCardNumber(v, name) {
            this[name] = v;
            this.manager[name] = v.replace(/ /g, '');
        },

        async submitIdentityDoc(data) {
            this.loading = true;
            const apartment_id = this.apartment._id;
            data.apartmentDocs = this.apartmentDocs;
            await axios
                .post(`/api/apartments/${apartment_id}/request_to_verify`, data)
                .then(async () => {
                    await createSupportRequest(this.supportRequest_id, {
                        text: 'ویرایش مجموعه در مرحله ارسال مدارک هویتی مدیر مجموعه'
                    });
                    this.finalStepDialog = true;
                })
                .catch(err => {
                    console.error(err);
                    if (err.response) {
                        this.error = err.response;
                        this.errorDialog = true;
                    }
                });
            this.loading = false;
        },

        async skipAddResidentsInfo() {
            this.finalStepDialog = false;
            await this.$router.push({name: 'Apartment', params: {apartment_id: this.apartment._id}});
        },
        async goToAddResidentInfo() {
            this.finalStepDialog = false;
            await this.$router.push({name: 'Units', params: {apartment_id: this.apartment._id}});
        },

        validateIdentityDoc() {
            this.$refs['send-identity-doc'].validate();
            this.showNavigationBar();
        },

        hideNavigationBar() {
            this.showNavigation(false);
        },
        showNavigationBar() {
            this.showNavigation(true);
        },
        ...mapActions([
            'setRole',
            'showNavigation',
            'showBreadCrumbs',
            'setBreadCrumbsTemp'
        ])
    },
    computed: {
        shebaInfo() {
            if (isShebaValid(this.manager.shebaNumber)) {
                const shebaInfo = getShebaInfo(this.manager.shebaNumber);
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.manager.accountNumber = shebaInfo.accountNumber;
                return shebaInfo;
            } else {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.manager.accountNumber = '';
                return {};
            }
        },
    },
    created() {
        this.acceptTheRules = false;
    }
}
</script>

<style scoped>

</style>